import { Component } from '@angular/core';

@Component({
  selector: 'app-why-mobile-wise',
  templateUrl: './why-mobile-wise.component.html',
  styleUrls: ['./why-mobile-wise.component.scss']
})
export class WhyMobileWiseComponent {

}
